import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from './login.service';
import { CookieStorageService } from '@sharedServices/cookie-storage.service';
import { RoleDialogComponent } from './role-dialog/role-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '@sharedServices/notification.service';
import { RedirectionLinksService } from '@sharedServices/redirection-links.service';
import { environment } from '@environment';
import { UtilService } from '@sharedServices/util.service'
import { RegexService } from '@sharedServices/regex.service';

enum AUTHORITIES {
  EMPLOYEE = 'EMPLOYEE',
  HOSPITAL = 'HOSPITAL',
  SUB_HOSPITAL = 'SUB_HOSPITAL',
  INSTITUTION = 'INSTITUTION'
}

const NAVIGATE_TO = {
  EMPLOYEE: 'adminApp',
  HOSPITAL: 'hospitalApp',
  SUB_HOSPITAL: 'hospitalApp',
  INSTITUTION: 'institutionApp'
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  appVersion = environment.appVersion
  loginForm: FormGroup
  isPassVisible: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private cookieStorageService: CookieStorageService,
    private _domSanitizer: DomSanitizer,
    private matDialog: MatDialog,
    private utilService: UtilService,
    private notificationService: NotificationService,
    private regexService: RegexService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.regexService.emailPattern)]],
      password: ['', Validators.required]
    })
  }
  /*============================================================================
                          PRIVATE
  ============================================================================*/
  private sanitizeCredentials(loginFormData, authorityType) {
    return {
      username: this._domSanitizer.sanitize(SecurityContext.HTML, loginFormData.username),
      password: this._domSanitizer.sanitize(SecurityContext.HTML, loginFormData.password),
      grant_type: this._domSanitizer.sanitize(SecurityContext.HTML, 'password'),
      authority: this._domSanitizer.sanitize(SecurityContext.HTML, authorityType)
    }
  }

  private getAuthToken(loginCredentials, authority) {
    const sanitizedCredentials = this.sanitizeCredentials(loginCredentials, authority)
    return new Promise(resolve => {

      this.loginService.getAuthToken(sanitizedCredentials).subscribe((response: { [key: string]: any }) => {
        if (authority === AUTHORITIES.EMPLOYEE) {
          if (response) {
            this.cookieStorageService.setCookie('webApp_userEmail', loginCredentials.username, response.expires_in)
            this.matDialog.open(RoleDialogComponent, { data: response })
          }
        } else {
          this.cookieStorageService.setCookie('webApp_userEmail', loginCredentials.username, response.expires_in)
          this.cookieStorageService.setCookie('webApp_accessToken', response.access_token, response.expires_in)
          this.cookieStorageService.setCookie('webApp_activeRole', AUTHORITIES[authority], response.expires_in)

          let redirectionUrl = RedirectionLinksService.getRedirectionLink(authority)

          if (redirectionUrl) {
            this.notificationService.showSuccess(`Successfully logged in as<br>${authority}`)
            this.router.navigateByUrl(NAVIGATE_TO[authority] + '/' + redirectionUrl)
          } else {
            this.notificationService.showError('App Inactive<br>Please contact ADMIN')
            this.cookieStorageService.clearAllCookies()
          }
        }
        resolve(true)
      }, () => {
        resolve(false)
      })
    })
  }

  /*============================================================================
                          HTML
  ============================================================================*/
  async getToken() {
    const authTokenObj = {
      username: this.loginForm.controls.email.value.toLowerCase(),
      password: this.utilService.md5Hash(this.loginForm.controls.password.value)
    }
    let gotToken = false
    for (let authority in NAVIGATE_TO) {
      if (await this.getAuthToken(authTokenObj, AUTHORITIES[authority])) {
        gotToken = true
        break
      }
    }
    if (!gotToken) {
      this.notificationService.showError('Username and/or Password is incorrect')
      this.loginForm.controls.password.setValue(null)
    }
  }
}
